import React, {useEffect, useRef, useState} from 'react';
import {
    Box, Button, Grid, Modal, TextField, Typography
} from "@mui/material";
import {Link, Navigate, Outlet, useLocation, useNavigate, useOutletContext, useParams} from "react-router-dom";
import LocationStepper from "./LocationStepper";

import btnClose from "../assets/buttons/close/close-nobackground.svg";
import btnCloseOver from "../assets/buttons/close/close-nobackground.svg";
import ImageButton from "./ImageButton";

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import {useTranslation} from "react-i18next";
import VehicleStepper from "./VehicleStepper";

export default function VehicleModal(props) {
    let params = useParams();

    const location = useLocation();

    const [activeStep, setActiveStep] = useState(parseInt(props.step));

    const [contentLoaded, setContentLoaded] = useState(false);
    const [vehicleData, setVehicleData] = useState(null);

    const previousBtnRef = useRef();
    const nextBtnRef = useRef();

    const childRef = useRef();

    const navigate = useNavigate();

    const [apiUri, vehicleUpdatedHandler] = useOutletContext();
    const {t} = useTranslation('common');
    useEffect(() => {
        setActiveStep(parseInt(props.step));
    }, [props.step])

    // TODO depend de là ou on s'est arrété ( donc on doit récupérer le contenu de l'appel api )
    function isEditMode() {
        if (
            location.pathname == '/vehicle/add' ||
            location.pathname.startsWith('/vehicle/add_step2')
        ) {
            return false;
        }
        return true;
    }

    function contentLoadedHandler(locationData) {
        setContentLoaded(true);
        setVehicleData(locationData);
    }

    // User clicked on a different step => Notify current content
    function changeStepFromMenuHandler(e, stepValue) {
        childRef.current.wantChangeTab(stepValue);
    }

    // Current content want to switch step
    function changeStepFromContentHandler(stepValue, newVehicleId = null) {
        // TODO Pas top , stocker les routes dans un tableau à part en commun avec la définition ?
        let path = null;
        let vehicleId = params.vehicleId;
        if (newVehicleId != null) {
            vehicleId = newVehicleId;
        }

        if (vehicleId == null) {
            console.log("No current vehicleId");
            return;
        }

        switch (stepValue) {
            case -1:
                path = '/vehicle/';
                vehicleUpdatedHandler();
                break;
            case 0 :
                path = '/vehicle/step1/' + vehicleId;
                break;
            case 1:
                if (newVehicleId != null)
                {
                    path = '/vehicle/add_step2/' + vehicleId;
                }
                else
                {
                    path = '/vehicle/step2/' + vehicleId;
                }
                break;
            default:
                console.log("Unknown step : " + stepValue);
                return;
        }

        // console.log("Navigating to " + path);
        navigate(path);
    }

    function closeButtonHandler() {
        vehicleUpdatedHandler();
    }

    return (
        <Modal
            open={true}
            style={{
                overflowY: 'scroll',
                // marginTop : '50vh',
                // display:'flex',
                // alignItems : 'center',
                // justifyContent : 'center'
            }}
            disableEnforceFocus
        >
            <div style={style}>
                <Box sx={styleInner}>
                    <Grid container justifyContent="flex-end">
                        <Grid item sx={{flexGrow: 1}}>
                            <Grid container justifyContent="center">
                                <h3>{
                                    contentLoaded && (
                                        vehicleData == null ?
                                            t('vehicle.modal_default_title')
                                            :
                                            vehicleData.name)
                                }</h3>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <ImageButton src={btnClose} srcOver={btnCloseOver} onClickHandler={closeButtonHandler}/>
                        </Grid>
                    </Grid>
                    <Box>
                        {contentLoaded &&
                        <VehicleStepper activeStep={activeStep} editMode={isEditMode()}
                                        changeStepHandler={changeStepFromMenuHandler}/>
                        }
                        {
                            React.cloneElement(props.children,
                                {
                                    previous_btn: previousBtnRef,
                                    next_btn: nextBtnRef,
                                    isEditMode: isEditMode(),
                                    changeStepFromContentHandler: changeStepFromContentHandler,
                                    contentLoadedHandler: contentLoadedHandler,
                                    ref: childRef
                                }
                            )}
                    </Box>

                    <Grid container justifyContent="center">
                        <Button ref={previousBtnRef}>
                            <NavigateBeforeIcon sx={
                                {
                                    color: 'orange',
                                    fontSize: 60,
                                }}/>
                        </Button>
                        {isEditMode() ?
                            <Button
                                ref={nextBtnRef}
                                variant="contained"
                                color="yellow"
                                sx={{mt: '15px', mb: '20px'}}
                            >
                                {t('common.save')}
                            </Button>
                            :
                            <Button ref={nextBtnRef}
                                    color="yellow">

                                {t('common.next_step')}
                                <NavigateNextIcon sx={
                                    {
                                        color: 'orange',
                                        fontSize: 60,
                                    }}/>
                            </Button>
                        }
                    </Grid>
                </Box>
            </div>
        </Modal>
    );
}

const style = {
    position: 'absolute',
    top: '2.5%',
    bottom: '2.5%',
    left: '2.5%',
    right: '2.5%',
};

const styleInner = {
    bgcolor: 'background.paper',
    border: '2px solid #000',
    minHeight: '100%'
}